<div class="mood-bar" [class.active]="playing" [class.mood-bar--unavailable]="unavailable">
  <div class="mb-transport">
    <button class="mb-btn mb-primary" (click)="toggle()" [disabled]="unavailable"
            [attr.aria-label]="unavailable
              ? 'Audio unavailable'
              : (playing ? 'Turn audio off' : 'Turn audio on')">
      <!-- Both icons are rendered and cross-faded, so play/pause dissolves instead of
           snapping. Stacked into one grid cell, so the button still sizes to one icon.
           Play is the app's signature caret (the same dropdown_arrow.svg the carousel
           pager and every widget header use), rotated to point right. -->
      <ion-icon src="assets/dropdown_arrow.svg" class="mb-icon mb-caret"
                [class.mb-icon--off]="playing"></ion-icon>
      <ion-icon name="pause" class="mb-icon" [class.mb-icon--off]="!playing"></ion-icon>
    </button>
  </div>

  <span class="mb-name">{{ displayName }}</span>

  <div class="mb-menu-group">
    <button class="mb-btn mb-menu" (click)="openPicker()" [disabled]="unavailable"
            [attr.aria-label]="unavailable ? 'Audio unavailable' : 'Change sound'">
      <ion-icon name="ellipsis-horizontal"></ion-icon>
    </button>
  </div>
</div>

<!-- Modal only: the bar's menu button presents it via ViewChild. -->
<sound-picker
  [panel]="false"
  [sounds]="state.library"
  [sound]="state.sound?.id ?? null"
  [duration]="state.duration"
  [volume]="volume"
  [showVolume]="true"
  (onSelected)="onPicked($event)"
  (onVolumeChanged)="onVolumePicked($event)"
></sound-picker>
